import React, { useState } from "react";
import { catalogueItemKey, usePublicCatalog } from "../../api/catalogApi";

const OurProducts = () => {
  const [visibleCount, setVisibleCount] = useState(8);
  const { services, products, loading, error } = usePublicCatalog();
  const serviceNames = new Map(
    services.map((service) => [
      `${service.company_id}:${service.id}`,
      service.name,
    ]),
  );

  return (
    <section
      style={{
        padding: "20px 20px",
        backgroundColor: "#ffffff",
        fontFamily: "sans-serif",
      }}
    >
      <div style={{ maxWidth: "1400px", margin: "0 auto" }}>
        <div style={{ textAlign: "center", marginBottom: "30px" }}>
          <h2
            style={{
              fontSize: "35px",
              fontWeight: "bold",
              color: "#bd06d3",
              textTransform: "uppercase",
              letterSpacing: "1px",
              margin: 0,
            }}
          >
            Our Products <span style={{ color: "#00bfff" }}>Gallery</span>
          </h2>
        </div>

        {loading ? (
          <p role="status" style={{ textAlign: "center", color: "#64748b" }}>
            Loading catalogue…
          </p>
        ) : error ? (
          <p role="alert" style={{ textAlign: "center", color: "#b91c1c" }}>
            {error}
          </p>
        ) : products.length === 0 ? (
          <p style={{ textAlign: "center", color: "#64748b" }}>
            No products are currently available.
          </p>
        ) : (
          <>
            <div
              style={{
                display: "grid",
                gridTemplateColumns:
                  "repeat(auto-fill, minmax(min(100%, 320px), 1fr))",
                gap: "25px",
              }}
            >
              {products.slice(0, visibleCount).map((product) => (
                <article
                  key={catalogueItemKey(product)}
                  style={{
                    backgroundColor: "#ffffff",
                    borderRadius: "12px",
                    overflow: "hidden",
                    border: "1px solid rgba(189, 6, 179, 0.12)",
                    boxShadow: "0 3px 12px rgba(189, 6, 179, 0.05)",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      height: "210px",
                      overflow: "hidden",
                      backgroundColor: "#f8fafc",
                    }}
                  >
                    {(product.image_url || product.gallery_urls?.[0]) ? (
                      <img
                        src={product.image_url || product.gallery_urls[0]}
                        alt={product.name}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          display: "block",
                        }}
                      />
                    ) : (
                      <div
                        aria-label="No product image available"
                        style={{ height: "100%" }}
                      />
                    )}
                  </div>

                  <div style={{ padding: "18px" }}>
                    <div
                      style={{
                        fontSize: "13px",
                        fontWeight: 700,
                        color: "#00bfff",
                        marginBottom: "7px",
                        letterSpacing: "0.3px",
                      }}
                    >
                      {product.company_name}
                      {serviceNames.get(
                        `${product.company_id}:${product.service_id}`,
                      ) && (
                        <span>
                          {" · "}
                          {serviceNames.get(
                            `${product.company_id}:${product.service_id}`,
                          )}
                        </span>
                      )}
                    </div>
                    <h3
                      style={{
                        fontSize: "18px",
                        fontWeight: 700,
                        color: "#bd06b3",
                        margin: "0 0 8px",
                        lineHeight: 1.4,
                      }}
                    >
                      {product.name}
                    </h3>
                    {product.description && (
                      <p
                        style={{
                          fontSize: "13px",
                          color: "#64748b",
                          margin: 0,
                          lineHeight: 1.6,
                        }}
                      >
                        {product.description}
                      </p>
                    )}
                  </div>
                </article>
              ))}
            </div>

            {products.length > 8 && (
              <div style={{ textAlign: "center", marginTop: "40px" }}>
                {visibleCount < products.length ? (
                  <button
                    type="button"
                    onClick={() => setVisibleCount((count) => count + 8)}
                    style={buttonStyle("#bd06d3")}
                  >
                    Show More ↓
                  </button>
                ) : (
                  <button
                    type="button"
                    onClick={() => setVisibleCount(8)}
                    style={buttonStyle("#334155")}
                  >
                    Show Less ↑
                  </button>
                )}
              </div>
            )}
          </>
        )}
      </div>
    </section>
  );
};

const buttonStyle = (backgroundColor) => ({
  backgroundColor,
  color: "#ffffff",
  border: "none",
  padding: "12px 30px",
  fontSize: "14px",
  fontWeight: "bold",
  borderRadius: "30px",
  cursor: "pointer",
});

export default OurProducts;
